import { z } from 'zod';

export const mastersPriceSchema = z
  .object({
    results: z.array(
      z.object({
        payment_plans_v2: z.array(
          z.object({
            upfront_amount: z.object({
              payable_amount_display: z.string(),
            }),
          })
        ),
      })
    ),
  })
  .transform((data) => data.results[0].payment_plans_v2[0].upfront_amount.payable_amount_display.replace(' USD', ''));

export type MastersPrice = z.infer<typeof mastersPriceSchema>;
export type MastersPriceResult = z.input<typeof mastersPriceSchema>;

// {"version":"2.114.0-2-ga93a30a72","results":[{"sku":{"urn":"urn:x-udacity:sku:degree_application:usd","name":"Master's Degree Application","status":"active","amount":{"amount":19900,"amount_display":"$199 USD","currency":"USD"},"node_keys":[],"learning_plan_key":null},"coupon":null,"payment_methods":["stripe","braintree"],"payment_plans_v2":[{"type":"one_time","description":"one time payment of $0 USD","next_due_date":null,"upfront_amount":{"original_amount":19900,"original_amount_display":"$199 USD","payable_amount":19900,"payable_amount_display":"$199 USD","discount_amount":0,"discount_amount_display":"$0 USD","currency":"USD"},"upfront_interval":null,"upfront_interval_count":null}],"upcoming_payments":[],"free_trial":false,"price":{"original_amount":19900,"original_amount_display":"$199 USD","payable_amount":19900,"payable_amount_display":"$199 USD","discount_amount":0,"discount_amount_display":"$0 USD","currency":"USD","coupon_applied":false,"coupon_applied_to_payment_plan":false},"degree_application_amount":0,"degree_application_amount_display":"$0 USD","coupon_applied":false,"coupon_applied_to_payment_plan":false}]}
